import { Grid, Typography } from '@mui/material';
import Page from '../../components/Page';
import PageHeader from '../../components/page-header';
import NaverMapComponent from './NaverMapComponent';
import TableCustomers from './TableCustomers';
import React, { useState } from "react";

const CustomerMap = () => {
    const [reload, setReload] = useState(0);
    const [selected, setSelected] = useState([]);

    return (
        <Page title="Map">
            <Grid container spacing={6}>
                <PageHeader
                    title={
                    <Typography variant='h5' color='#666CFF'>
                        고객사맵
                    </Typography>
                    }
                    subtitle={
                    <Typography variant='body2'>
                        해당 마커를 click하면 상세정보를 지도에서 확인할 수 있습니다. 다시 클릭하면 마커가 사라집니다.
                    </Typography>
                    }
                />
                <Grid item xs={12}>
                    <NaverMapComponent selected={selected} reload={reload} />
                </Grid>
                <Grid item xs={12}>
                    <TableCustomers reload={reload} setReload={setReload} selected={selected} setSelected={setSelected} />
                </Grid>                
            </Grid>
        </Page>
    )
}

export default CustomerMap